export default __webpack_public_path__ + "static/media/as-card.1c7acd7b.png";